import React from "react";
import { Container } from "react-bootstrap";
import { FaFacebook, FaTiktok, FaInstagram, FaEnvelope, FaPhone } from "react-icons/fa";

const ContactUs = () => {
  return (

    <Container className="text-center py-5" style={{ maxWidth: "600px" }}>
      <h3 >Contact Us</h3>

      <img src="/faithcontactus.png" alt="Cupcake Mascot" className="img-fluid" style={{ maxWidth: "400px" }} />
      <p className="text-muted">We're always improving and we value your feedback.  </p>
 
      <p className="text-muted">If you're experiencing any issues, please describe them in detail, and we’ll work to resolve them as soon as possible.</p>
      <p className="text-muted">We appreciate your patience and will get back to you as quickly as we can.</p>
      {/* Email */}
      <div className="mb-3">
        <FaEnvelope size={20} className="me-2 text-primary" />
        <a href="mailto:gocakery@gmail.com" className="text-dark">gocakery@gmail.com</a>
      </div>

      {/* Phone */}
      {/* <div className="mb-3">
        <FaPhone size={20} className="me-2 text-success" />
        <a href="tel:+1234567890" className="text-dark">+1 (234) 567-890</a>
      </div> */}

      {/* Social Media Links */}
      <h4  style={{ color: "#FEA2C2" }}>Follow Us</h4>
      <div className="d-flex justify-content-center gap-4">
        <a href="https://www.facebook.com/share/14h5nG1G5J/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
          <FaFacebook size={40} className="text-primary" />
        </a>
        <a href="https://www.tiktok.com/@cakeryhq?_t=ZT-8ukWwuQLAIo&_r=1" target="_blank" rel="noopener noreferrer">
          <FaTiktok size={40} className="text-dark" />
        </a>
        <a href="https://www.instagram.com/cakeryhq?igsh=NHRqdHJvYTR4d28x&utm_source=qr" target="_blank" rel="noopener noreferrer">
          <FaInstagram size={40} className="text-danger" />
        </a>
      </div>
    </Container>

  );
};

export default ContactUs;
